import { useEffect, useState } from 'react';
import { Shell } from '../../components/layout/Shell.jsx';
import { Bar } from '../../components/ui/Bar.jsx';
import { Btn } from '../../components/ui/Btn.jsx';
import { Card } from '../../components/ui/Card.jsx';
import { Inp, NumInput, inpFS } from '../../components/ui/Inputs.jsx';
import { Pill } from '../../components/ui/Pill.jsx';
import { CMD_STATUTS } from '../../constants/documents';
import { adresseAssemblee } from '../../lib/adresse';
import { DEVISE, fmt } from '../../lib/currency';
import { decCmd, remiseClient } from '../../lib/discounts';
import { liensPublicsApi } from '../../api/resources';
import { ordreDeSaisie } from '../../lib/ordre';
import { today, uid } from '../../lib/utils';
import { C } from '../../theme/palette';
import { messageCommande } from '../../lib/lien-commande';
import { AccesEnLigneClient } from './AccesEnLigneClient.jsx';

export function CommandesPage({
  onNav,
  soc,
  commandes,
  setCommandes,
  clients,
  stock,
  livraisons,
  setLivraisons,
  estMixte,
  univers,
  setUnivers,
  ouvrir,
}) {
  const estMag = estMixte ? univers === 'magasin' : soc?.secteur === 'magasin';
  const [view, setView] = useState('liste');
  const [selId, setSelId] = useState(null);
  // La cloche mène à la commande elle-même, pas à la liste où la chercher.
  useEffect(() => {
    if (ouvrir?.commandeId == null) return;
    setSelId(ouvrir.commandeId);
    setView('detail');
  }, [ouvrir]);
  const [form, setForm] = useState(null);
  const [artQ, setArtQ] = useState('');
  const [impOpen, setImpOpen] = useState(false);
  const [impTxt, setImpTxt] = useState('');
  const [impErr, setImpErr] = useState('');
  const [copied, setCopied] = useState(null);
  // Liens de commande par client, demandés au serveur quand l'écran s'ouvre :
  // url par client, ou le message du refus.
  const [liens, setLiens] = useState({});
  useEffect(() => {
    if (view !== 'liens') return undefined;
    let annule = false;
    (async () => {
      for (const c of clients) {
        try {
          const lien = await liensPublicsApi.pour('commande', c.id);
          if (!annule) setLiens((p) => ({ ...p, [c.id]: { url: lien.url } }));
        } catch (e) {
          if (!annule) {
            setLiens((p) => ({ ...p, [c.id]: { erreur: e?.message || 'Lien indisponible.' } }));
          }
        }
      }
    })();
    return () => {
      annule = true;
    };
  }, [view, clients]);
  const sel = commandes.find((c) => c.id === selId);
  const remisePour = (cl, ref) => remiseClient(cl, ref);
  const totalC = (c) =>
    (c.lignes || []).reduce((s, l) => s + l.q * l.p * (1 - (l.rem || 0) / 100), 0);

  if (view === 'liens') {
    const copier = (c) => {
      const url = liens[c.id]?.url;
      if (!url) return;
      try {
        navigator.clipboard && navigator.clipboard.writeText(messageCommande(c, url, soc));
      } catch (e) {}
      setCopied(c.id);
      setTimeout(() => setCopied(null), 1500);
    };
    return (
      <Shell
        active="plus"
        onNav={onNav}
        soc={soc}
        back
        onBack={() => setView('liste')}
        pageTitle="🛒 Clients en ligne"
        estMixte={estMixte}
        univers={univers}
        setUnivers={setUnivers}
      >
        <div
          style={{
            background: C.tealL,
            border: '1px solid ' + C.teal + '30',
            borderRadius: 11,
            padding: '11px 13px',
            marginBottom: 12,
            fontSize: 9,
            color: C.grey,
            lineHeight: 1.6,
          }}
        >
          <b>Invite tes clients à commander en ligne</b> : la personne invitée (patron, technicien…)
          crée son compte avec son mot de passe, puis invite son équipe. Chacun voit ton stock{' '}
          <b>aux prix et remises du client</b> et commande. Tu reçois la commande ici, avec le nom
          de qui l'a passée, et par e-mail. Le lien personnel reste possible pour commander sans
          compte.
        </div>
        {clients.map((c) => {
          const lien = liens[c.id];
          const nbRem = Object.keys(c.remises || {}).length + (c.remiseGlobale > 0 ? 1 : 0);
          return (
            <Card key={c.id} style={{ marginBottom: 9 }}>
              <div style={{ padding: '11px 13px' }}>
                <div
                  style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: 7,
                  }}
                >
                  <div>
                    <div style={{ fontSize: 11, fontWeight: 800 }}>{c.nom}</div>
                    <div style={{ fontSize: 8, color: C.muted }}>
                      {(c.points || 0) > 0 ? '⭐ ' + c.points + ' pts · ' : ''}
                      {nbRem > 0 ? nbRem + ' remise(s) perso.' : 'Prix catalogue'}
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    background: C.navyXL,
                    borderRadius: 8,
                    padding: '7px 9px',
                    marginBottom: 7,
                  }}
                >
                  <span
                    data-testid={'lien-commande-' + c.id}
                    style={{
                      flex: 1,
                      fontSize: 8,
                      color: lien?.erreur ? C.red : C.grey,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                      whiteSpace: 'nowrap',
                    }}
                  >
                    {lien?.url || lien?.erreur || 'Lien en préparation…'}
                  </span>
                </div>
                {/* Le message prêt à partir : le lien, et l'écran d'accueil où
                    le poser pour commander en un geste. */}
                <a
                  href={
                    lien?.url
                      ? 'https://wa.me/' +
                        String(c.tel || '')
                          .replace(/[^\d]/g, '')
                          .replace(/^0(?=\d{9}$)/, '41') +
                        '?text=' +
                        encodeURIComponent(messageCommande(c, lien.url, soc))
                      : undefined
                  }
                  target="_blank"
                  rel="noreferrer"
                  aria-disabled={!lien?.url}
                  style={{ textDecoration: 'none', display: 'block', marginBottom: 6 }}
                >
                  <Btn
                    label="💬 Envoyer au client (WhatsApp)"
                    sm
                    color={C.green}
                    full
                    disabled={!lien?.url}
                  />
                </a>
                <div style={{ display: 'flex', gap: 6 }}>
                  <div style={{ flex: 1 }}>
                    <Btn
                      label={copied === c.id ? '✓ Copié' : '📋 Copier le lien'}
                      sm
                      color={copied === c.id ? C.green : C.teal}
                      full
                      disabled={!lien?.url}
                      onClick={() => copier(c)}
                    />
                  </div>
                  <div style={{ flex: 1 }}>
                    {/* La page même que le client ouvrira, dans un autre onglet. */}
                    <Btn
                      label="👁 Aperçu client"
                      sm
                      ghost
                      color={C.navy}
                      full
                      disabled={!lien?.url}
                      onClick={() => {
                        try {
                          window.open(lien.url, '_blank', 'noopener');
                        } catch (e) {}
                      }}
                    />
                  </div>
                </div>
                <AccesEnLigneClient client={c} />
              </div>
            </Card>
          );
        })}
        {clients.length === 0 && (
          <Card>
            <div style={{ padding: 20, textAlign: 'center', color: C.muted, fontSize: 11 }}>
              Ajoute d'abord des clients.
            </div>
          </Card>
        )}
      </Shell>
    );
  }

  if (view === 'creer' && form) {
    const cl = clients.find((c) => c.id === form.clientId);
    return (
      <Shell
        active="plus"
        onNav={onNav}
        soc={soc}
        back
        onBack={() => setView('liste')}
        pageTitle="Nouvelle commande"
        estMixte={estMixte}
        univers={univers}
        setUnivers={setUnivers}
      >
        <Card style={{ marginBottom: 11 }}>
          <Bar icon="📦" title="Client & articles" color={C.navy} />
          <div style={{ padding: 13 }}>
            <Inp label="Client">
              <select
                value={form.clientId}
                onChange={(e) => setForm((p) => ({ ...p, clientId: +e.target.value }))}
                style={{
                  width: '100%',
                  border: '1px solid ' + C.border,
                  borderRadius: 9,
                  padding: '10px',
                  fontSize: 11,
                }}
              >
                {clients.map((c) => (
                  <option key={c.id} value={c.id}>
                    {c.nom}
                  </option>
                ))}
              </select>
            </Inp>
            <Inp label={estMag ? 'Adresse de livraison' : 'Adresse du chantier (livraison)'}>
              <input
                value={form.livAdr || ''}
                onChange={(e) => setForm((p) => ({ ...p, livAdr: e.target.value }))}
                placeholder="Rue, NPA, localité"
                style={{
                  width: '100%',
                  boxSizing: 'border-box',
                  border: '1px solid ' + C.border,
                  borderRadius: 9,
                  padding: '10px',
                  fontSize: 11,
                }}
              />
            </Inp>
            <input
              value={artQ}
              onChange={(e) => setArtQ(e.target.value)}
              placeholder="🔎 Ajouter un article du stock…"
              style={inpFS}
            />
            {artQ && (
              <div
                style={{
                  border: '1px solid ' + C.border,
                  borderRadius: 9,
                  marginBottom: 8,
                  maxHeight: 160,
                  overflowY: 'auto',
                }}
              >
                {stock
                  .filter((a) => a.nom.toLowerCase().includes(artQ.toLowerCase()))
                  .slice(0, 6)
                  .map((a) => {
                    const rem = remisePour(cl, a.ref);
                    return (
                      <div
                        key={a.id}
                        onClick={() => {
                          setForm((p) => ({
                            ...p,
                            lignes: [
                              ...p.lignes,
                              {
                                id: uid(),
                                d: a.nom,
                                u: a.u,
                                q: 1,
                                p: a.pv,
                                rem,
                                ref: a.ref,
                                tva: a.tva,
                              },
                            ],
                          }));
                          setArtQ('');
                        }}
                        style={{
                          padding: '9px 11px',
                          borderBottom: '1px solid ' + C.border,
                          cursor: 'pointer',
                          display: 'flex',
                          justifyContent: 'space-between',
                        }}
                      >
                        <span style={{ fontSize: 10 }}>{a.nom}</span>
                        <span style={{ fontSize: 9, color: C.green }}>
                          {DEVISE} {fmt(a.pv)}
                          {rem > 0 ? ' −' + rem + '%' : ''}
                        </span>
                      </div>
                    );
                  })}
              </div>
            )}
            {form.lignes.map((l) => (
              <div
                key={l.id}
                style={{
                  background: C.navyXL,
                  borderRadius: 9,
                  padding: '9px 11px',
                  marginBottom: 7,
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 5 }}>
                  <span style={{ fontSize: 10, fontWeight: 700 }}>{l.d}</span>
                  <button
                    onClick={() =>
                      setForm((p) => ({ ...p, lignes: p.lignes.filter((x) => x.id !== l.id) }))
                    }
                    style={{ background: 'none', border: 'none', color: C.red, cursor: 'pointer' }}
                  >
                    ✕
                  </button>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                  <span style={{ fontSize: 8, color: C.muted }}>Qté</span>
                  <NumInput
                    value={l.q}
                    onChange={(e) =>
                      setForm((p) => ({
                        ...p,
                        lignes: p.lignes.map((x) =>
                          x.id === l.id ? { ...x, q: +e.target.value || 1 } : x,
                        ),
                      }))
                    }
                    style={{
                      width: 54,
                      border: '1px solid ' + C.border,
                      borderRadius: 7,
                      padding: '5px',
                      fontSize: 10,
                      textAlign: 'center',
                    }}
                  />
                  <span style={{ fontSize: 8, color: C.muted }}>
                    {l.u} · −{l.rem || 0}%
                  </span>
                  <span style={{ marginLeft: 'auto', fontSize: 12, fontWeight: 800 }}>
                    {DEVISE} {fmt(l.q * l.p * (1 - (l.rem || 0) / 100))}
                  </span>
                </div>
              </div>
            ))}
          </div>
        </Card>
        <Btn
          label="✓ Créer la commande"
          color={C.green}
          full
          disabled={!form.lignes.length}
          onClick={() => {
            const id =
              'CMD-' +
              new Date().getFullYear() +
              '-' +
              String(commandes.length + 1).padStart(3, '0');
            setCommandes((p) => [{ ...form, id, date: today(), statut: 'À préparer' }, ...p]);
            setView('liste');
          }}
        />
      </Shell>
    );
  }

  if (view === 'detail' && sel) {
    const cl = clients.find((c) => c.id === sel.clientId);
    const col = CMD_STATUTS[sel.statut] || C.muted;
    // Deux traces du meme lien, et c'est voulu : la commande retient la
    // reference du bon, le bon retient la commande. La seconde suffit quand
    // la premiere manque — une commande d'avant ce lien, un bon etabli
    // ailleurs — et evite de proposer un second bon pour la meme marchandise.
    // Le numero du bon d'abord : la commande peut ne retenir que son
    // identifiant d'enregistrement, et l'ecran annoncait « Bon de livraison 2 ».
    const bonLie =
      (livraisons || []).find((b) => String(b.commandeId) === String(sel.id))?.num ||
      sel.blId ||
      null;
    return (
      <Shell
        active="plus"
        onNav={onNav}
        soc={soc}
        back
        onBack={() => setView('liste')}
        pageTitle={sel.num || sel.id}
        estMixte={estMixte}
        univers={univers}
        setUnivers={setUnivers}
      >
        <Card style={{ marginBottom: 11 }}>
          <div
            style={{
              padding: '12px 14px',
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'flex-start',
            }}
          >
            <div>
              <div style={{ fontSize: 12, fontWeight: 800 }}>{sel.num || sel.id}</div>
              <div style={{ fontSize: 9, color: C.grey }}>
                {cl?.nom} · {sel.date}
              </div>
              {sel.livAdr && (
                <div style={{ fontSize: 9, color: C.teal, fontWeight: 700, marginTop: 2 }}>
                  📍 Livraison : {sel.livAdr}
                </div>
              )}
            </div>
            <Pill label={sel.statut} color={col} size={8} />
          </div>
          <div style={{ padding: '0 14px 14px' }}>
            {(sel.lignes || []).map((l, i) => (
              <div
                key={i}
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '7px 0',
                  borderBottom: '1px solid ' + C.border,
                  fontSize: 10,
                }}
              >
                <span>
                  {l.d} · {l.q} {l.u}
                  {l.rem > 0 ? ' −' + l.rem + '%' : ''}
                </span>
                <b>
                  {DEVISE} {fmt(l.q * l.p * (1 - (l.rem || 0) / 100))}
                </b>
              </div>
            ))}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: 8,
                padding: '8px 11px',
                background: C.navy,
                borderRadius: 8,
              }}
            >
              <span style={{ fontSize: 11, fontWeight: 800, color: '#fff' }}>Total HT</span>
              <span style={{ fontSize: 14, fontWeight: 900, color: '#fff' }}>
                {DEVISE} {fmt(totalC(sel))}
              </span>
            </div>
          </div>
        </Card>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
          {sel.statut === 'Reçue' && (
            <Btn
              label="✓ Accepter la commande"
              color={C.amber}
              full
              onClick={() =>
                setCommandes((p) =>
                  p.map((c) => (c.id === sel.id ? { ...c, statut: 'À préparer' } : c)),
                )
              }
            />
          )}
          {sel.statut === 'À préparer' && (
            <Btn
              label="✓ Marquer prête"
              color={C.teal}
              full
              onClick={() =>
                setCommandes((p) => p.map((c) => (c.id === sel.id ? { ...c, statut: 'Prête' } : c)))
              }
            />
          )}
          {!bonLie &&
            (sel.statut === 'Prête' || sel.statut === 'À préparer' || sel.statut === 'Reçue') && (
              <Btn
                label="🚚 Créer bon de livraison"
                color={C.green}
                full
                onClick={() => {
                  const id =
                    'BL-' +
                    new Date().getFullYear() +
                    '-' +
                    String((livraisons?.length || 0) + 1).padStart(3, '0');
                  setLivraisons &&
                    setLivraisons((p) => [
                      {
                        id,
                        clientId: sel.clientId,
                        adr:
                          sel.livAdr && sel.livAdr.trim()
                            ? sel.livAdr
                            : adresseAssemblee(cl?.adr, cl?.npa),
                        date: today(),
                        statut: 'À livrer',
                        facture: false,
                        sig: '',
                        signePar: '',
                        lignes: sel.lignes,
                        commandeId: sel.id,
                      },
                      ...p,
                    ]);
                  setCommandes((p) =>
                    p.map((c) => (c.id === sel.id ? { ...c, statut: 'Prête', blId: id } : c)),
                  );
                  setView('liste');
                }}
              />
            )}
        </div>
        {bonLie && (
          <div
            style={{
              fontSize: 9.5,
              color: C.green,
              fontWeight: 800,
              marginTop: 9,
              textAlign: 'center',
            }}
          >
            {sel.statut === 'Livrée' ? (
              <>✓ Commande livrée — bon de livraison {bonLie}</>
            ) : (
              <>✓ Bon de livraison {bonLie} créé — à livrer & faire signer dans « Livraisons »</>
            )}
          </div>
        )}
        <div style={{ marginTop: 8 }}>
          <Btn
            label="🗑 Supprimer la commande"
            ghost
            danger
            color={C.red}
            full
            onClick={() => {
              setCommandes((p) => p.filter((c) => c.id !== sel.id));
              setView('liste');
            }}
          />
        </div>
      </Shell>
    );
  }

  return (
    <Shell
      active="plus"
      onNav={onNav}
      soc={soc}
      pageTitle="📦 Commandes clients"
      estMixte={estMixte}
      univers={univers}
      setUnivers={setUnivers}
    >
      <div
        onClick={() => {
          setForm({ clientId: clients[0]?.id || '', livAdr: '', lignes: [] });
          setView('creer');
        }}
        style={{
          background: C.navy,
          borderRadius: 12,
          padding: 16,
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 8,
          marginBottom: 9,
        }}
      >
        <span style={{ fontSize: 22, color: '#fff' }}>＋</span>
        <span style={{ fontSize: 14, fontWeight: 800, color: '#fff' }}>Nouvelle commande</span>
      </div>
      <div
        onClick={() => {
          setCopied(null);
          setView('liens');
        }}
        style={{
          border: '1.5px dashed ' + C.teal,
          background: C.tealL,
          borderRadius: 12,
          padding: '13px 14px',
          cursor: 'pointer',
          display: 'flex',
          alignItems: 'center',
          gap: 11,
          marginBottom: 12,
        }}
      >
        <span style={{ fontSize: 20 }}>🔗</span>
        <div style={{ flex: 1 }}>
          <div style={{ fontSize: 11.5, fontWeight: 800, color: C.teal }}>
            Clients en ligne : comptes et liens de commande
          </div>
          <div style={{ fontSize: 8.5, color: C.grey, marginTop: 1 }}>
            Invite tes clients et leurs équipes : ils commandent eux-mêmes, à leurs prix.
          </div>
        </div>
        <span style={{ fontSize: 16, color: C.teal }}>›</span>
      </div>
      <div style={{ marginBottom: 12 }}>
        {!impOpen ? (
          <Btn
            label="📥 Importer une commande reçue (code)"
            sm
            ghost
            color={C.navy}
            full
            onClick={() => {
              setImpOpen(true);
              setImpErr('');
            }}
          />
        ) : (
          <Card>
            <div style={{ padding: 12 }}>
              <div style={{ fontSize: 10, fontWeight: 800, marginBottom: 6 }}>
                Coller le code reçu (WhatsApp / e-mail)
              </div>
              <textarea
                value={impTxt}
                onChange={(e) => setImpTxt(e.target.value)}
                placeholder="STCMD..."
                style={{
                  width: '100%',
                  boxSizing: 'border-box',
                  minHeight: 64,
                  border: '1px solid ' + C.border,
                  borderRadius: 9,
                  padding: '9px',
                  fontSize: 10,
                }}
              />
              {impErr && <div style={{ fontSize: 9, color: C.red, marginTop: 5 }}>{impErr}</div>}
              <div style={{ display: 'flex', gap: 6, marginTop: 7 }}>
                <div style={{ flex: 1 }}>
                  <Btn
                    label="✓ Importer"
                    sm
                    color={C.green}
                    full
                    disabled={!impTxt.trim()}
                    onClick={() => {
                      const o = decCmd(impTxt);
                      if (!o || !o.l) {
                        setImpErr('Code invalide ou incomplet.');
                        return;
                      }
                      const id =
                        'CMD-' +
                        new Date().getFullYear() +
                        '-' +
                        String(commandes.length + 1).padStart(3, '0');
                      const blId =
                        'BL-' +
                        new Date().getFullYear() +
                        '-' +
                        String((livraisons?.length || 0) + 1).padStart(3, '0');
                      const lg = (o.l || []).map((x) => ({
                        id: uid(),
                        d: x.d,
                        u: x.u,
                        q: x.q,
                        p: x.p,
                        rem: x.m || 0,
                        ref: x.r,
                      }));
                      const clx = clients.find((c) => c.id === o.c);
                      setCommandes((p) => [
                        {
                          id,
                          clientId: o.c,
                          date: today(),
                          statut: 'Prête',
                          livAdr: o.a || '',
                          // Le badge « en ligne » se lit dans `source`, que le
                          // serveur conserve ; `enLigne` seul disparaissait au
                          // rechargement.
                          source: 'code',
                          enLigne: true,
                          blId,
                          lignes: lg,
                        },
                        ...p,
                      ]);
                      setLivraisons &&
                        setLivraisons((p) => [
                          {
                            id: blId,
                            clientId: o.c,
                            adr:
                              o.a && o.a.trim()
                                ? o.a
                                : adresseAssemblee(clx && clx.adr, clx && clx.npa),
                            date: today(),
                            statut: 'À livrer',
                            facture: false,
                            sig: '',
                            signePar: '',
                            lignes: lg,
                            commandeId: id,
                          },
                          ...p,
                        ]);
                      setImpTxt('');
                      setImpErr('');
                      setImpOpen(false);
                    }}
                  />
                </div>
                <Btn
                  label="Annuler"
                  sm
                  ghost
                  color={C.grey}
                  onClick={() => {
                    setImpOpen(false);
                    setImpTxt('');
                    setImpErr('');
                  }}
                />
              </div>
            </div>
          </Card>
        )}
      </div>
      {commandes.length === 0 && (
        <Card>
          <div style={{ padding: 20, textAlign: 'center', color: C.muted, fontSize: 11 }}>
            Aucune commande
          </div>
        </Card>
      )}
      {ordreDeSaisie(commandes).map((c) => {
        const cl = clients.find((x) => x.id === c.clientId);
        const col = CMD_STATUTS[c.statut] || C.muted;
        return (
          <Card
            key={c.id}
            style={{ marginBottom: 9, cursor: 'pointer', borderLeft: '4px solid ' + col }}
            onClick={() => {
              setSelId(c.id);
              setView('detail');
            }}
          >
            <div
              style={{
                padding: '12px 14px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
              }}
            >
              <div>
                <div style={{ fontSize: 11, fontWeight: 800 }}>
                  {c.num || c.id}
                  {c.enLigne && (
                    <span style={{ fontSize: 7.5, color: C.teal, fontWeight: 700, marginLeft: 6 }}>
                      🔗 en ligne
                    </span>
                  )}
                </div>
                <div style={{ fontSize: 10, color: C.grey }}>
                  {cl?.nom} · {(c.lignes || []).length} article(s)
                </div>
                <div style={{ fontSize: 8, color: C.muted }}>
                  {c.date}
                  {c.demandePar ? ' · 👤 ' + c.demandePar : ''}
                </div>
              </div>
              <div style={{ textAlign: 'right' }}>
                <Pill label={c.statut} color={col} size={8} />
                <div style={{ fontSize: 13, fontWeight: 900, marginTop: 4, whiteSpace: 'nowrap' }}>
                  {DEVISE} {fmt(totalC(c))}
                </div>
              </div>
            </div>
          </Card>
        );
      })}
    </Shell>
  );
}
